export default __webpack_public_path__ + "static/media/C0004.c63206e0.png";